import React from 'react'
import cn from 'classnames'
import Router from 'next/router'

import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { ReadingPageHeaderProps } from './interface'

export function ReadingPageHeader({
  chapterName,
  chapterTitle,
  totalPage,
}: ReadingPageHeaderProps) {
  const { isLightOrSepiaTheme, isDarkTheme } = useTheme()

  return (
    <div
      className={cn(
        'dark:text-dark-10 space-y-[20px] mb-[50px] mobile:space-y-[10px] mobile:mb-[40px]',
        {
          'text-secondary': isLightOrSepiaTheme,
          '!text-gray-16':
            isDarkTheme &&
            Router.pathname === '/story/[id]/chapter/[chapterId]',
        }
      )}
    >
      <h1
        data-test='story-name'
        className='text-center text-[24px] font-bold mobile:text-[12px] break-word'
      >
        {chapterTitle} {chapterName}
      </h1>

      {totalPage && (
        <div
          className={cn(
            'text-[18px] font-light mt-[20px] mobile:text-[12px] mobile:mt-[10px] dark:text-dark-10 tablet-mobile:hidden text-right',
            {
              'text-secondary-1': isLightOrSepiaTheme,
              'text-gray-16': isDarkTheme,
            }
          )}
        >
          จำนวน :{' '}
          <span
            className={cn('font-medium dark:text-dark-10', {
              'text-secondary': isLightOrSepiaTheme,
              'text-gray-16': isDarkTheme,
            })}
          >
            {totalPage.toLocaleString()}{' '}
          </span>
          หน้า
        </div>
      )}
    </div>
  )
}
